// See generateAudienceName() definition in audienceNameMixin.js for explanation of `adj` and `noun` fields
export default {
  location: {
    required: true,
    label: 'What nationality will you be targeting?',
    imageOnly: true, // Audience card displays only the icon image
    options: {
      uk: {
        name: 'UK',
        adj: 'British', // For audience summary string: e.g. 'Young <adj> males interested in sports' => 'Young British males interested in sports'
        noun: 'Brits', // For audience summary string: e.g. 'Young <noun> interested in sports' => 'Young Brits interested in sports'
        image: {
          image: require('@/assets/images/test-builder/flag-UK.png')
          // image: 'placeholder'
        }
      },
      us: {
        name: 'US',
        adj: 'American',
        noun: 'Americans',
        image: {
          image: require('@/assets/images/test-builder/flag-US.png')
          // image: 'placeholder'
        }
      }
    }
  },
  gender: {
    required: true,
    label: "What's the gender?",
    options: {
      none: {
        name: 'All',
        image: {
          image: require('@/assets/images/test-builder/no-gender-icon.svg')
          // image: 'placeholder'
        }
      },
      male: {
        name: 'Male',
        adj: 'Male',
        noun: 'Men',
        image: {
          image: require('@/assets/images/test-builder/male-icon.svg')
          // image: 'placeholder'
        }
      },
      female: {
        name: 'Female',
        adj: 'Female',
        noun: 'Women',
        image: {
          image: require('@/assets/images/test-builder/female-icon.svg')
          // image: 'placeholder'
        }
      }
    }
  },
  demographic: {
    label: "What's the demographic?",
    descriptionOnly: true, // Audience card displays name, description & summary. Sightly wider card than default
    options: {
      'gen-z': {
        name: 'Generation Z',
        adj: 'Generation Z', // For audience summary string: e.g. '<adj> British males interested in sports' => 'Generation Z British males interested in sports'
        description: '"Post millennials" born after 1997',
        summary: '18 and younger'
      },
      seniors: {
        name: 'Seniors',
        noun: 'Seniors', // For audience summary string: e.g. 'male British <noun> interested in sports' => 'male British seniors interested in sports'
        description: 'A broad group of older working and retired adults',
        summary: '70+'
      },
      adults: {
        name: 'General adults',
        noun: 'Adults',
        description: 'A broad section of the working adult population',
        summary: '19-50'
      },
      'mature-adults': {
        name: 'Mature adults',
        adj: 'Mature',
        noun: 'Adults',
        description: 'A broad group o older working and retired adults',
        summary: '50-70'
      },
      'young-couple': {
        name: 'Young couples',
        adj: 'Young',
        noun: 'Couples',
        description: 'Married with no kids',
        summary: '23-35'
      },
      millennials: {
        name: 'Millennials',
        adj: 'Millennial',
        description: 'The first truly digital native generation',
        summary: '19-35'
      },
      'young-professionals': {
        name: 'Young professionals',
        adj: 'Young',
        noun: 'Professionals',
        description: 'Moving on, left home and in employment',
        summary: '21-28'
      },
      'older-parents': {
        name: 'Older parents',
        adj: 'Older',
        noun: 'Parents',
        description: 'Parents with children over five',
        summary: '36-50'
      },
      'young-parents': {
        name: 'Young parents',
        adj: 'Young',
        noun: 'Parents',
        description: 'Parents with one or two children under five',
        summary: '23-35'
      }
    }
  },
  interests: {
    label: 'What are they in to?',
    options: {
      tech: {
        name: 'Tech',
        image: {
          emoji: '🤖'
        }
      },
      beauty: {
        name: 'Beauty',
        image: {
          emoji: '💄'
        }
      },
      fashion: {
        name: 'Fashion',
        image: {
          emoji: '👟'
        }
      },
      food: {
        name: 'Food',
        image: {
          emoji: '🌮'
        }
      },
      travel: {
        name: 'Travel',
        image: {
          emoji: '🏝️'
        }
      },
      fitness: {
        name: 'Fitness',
        image: {
          emoji: '🏊'
        }
      },
      education: {
        name: 'Education',
        image: {
          emoji: '🎓'
        }
      },
      wellbeing: {
        name: 'Wellbeing',
        image: {
          emoji: '😌'
        }
      },
      music: {
        name: 'Music',
        image: {
          emoji: '🎹'
        }
      },
      'tv-and-gaming': {
        name: 'TV & Gaming',
        image: {
          emoji: '📺'
        }
      }
    }
  }
}
